<script setup lang="ts">
import { useDateTimeStore } from '@/stores/dateTimeStore';
import DateTimeFormatter from '../formatters/DateTimeFormatter.vue';

const dateTimeStore = useDateTimeStore();
</script>

<template>
  <DateTimeFormatter :value="dateTimeStore.currentDateTime" format="short" />
</template>
